import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const Location: React.FC = () => (
  <Box sx={{ p: 3, maxWidth: 700, mx: 'auto' }}>
    <Typography variant="h4" gutterBottom>Location</Typography>
    <Card>
      <CardContent>
        <Typography variant="body1">Location features will be displayed here. (Mock data for now)</Typography>
      </CardContent>
    </Card>
  </Box>
);

export default Location; 